import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Dimensions, StyleSheet } from "react-native";
import { NativeSafeAreaProvider } from "./NativeSafeAreaProvider";
var isDev = process.env.NODE_ENV !== "production";
export var SafeAreaInsetsContext = /*#__PURE__*/ React.createContext(null);
if (isDev) {
    SafeAreaInsetsContext.displayName = "SafeAreaInsetsContext";
}
export var SafeAreaFrameContext = /*#__PURE__*/ React.createContext(null);
if (isDev) {
    SafeAreaFrameContext.displayName = "SafeAreaFrameContext";
}
export function SafeAreaProvider(_param) {
    var children = _param.children, initialMetrics = _param.initialMetrics, initialSafeAreaInsets = _param.initialSafeAreaInsets, style = _param.style, others = _object_without_properties(_param, [
        "children",
        "initialMetrics",
        "initialSafeAreaInsets",
        "style"
    ]);
    var parentInsets = useParentSafeAreaInsets();
    var parentFrame = useParentSafeAreaFrame();
    var _initialMetrics_insets, _ref, _ref1;
    var _React_useState = _sliced_to_array(React.useState((_ref1 = (_ref = (_initialMetrics_insets = initialMetrics === null || initialMetrics === void 0 ? void 0 : initialMetrics.insets) !== null && _initialMetrics_insets !== void 0 ? _initialMetrics_insets : initialSafeAreaInsets) !== null && _ref !== void 0 ? _ref : parentInsets) !== null && _ref1 !== void 0 ? _ref1 : null), 2), insets = _React_useState[0], setInsets = _React_useState[1];
    var _initialMetrics_frame, _ref2;
    var _React_useState1 = _sliced_to_array(React.useState((_ref2 = (_initialMetrics_frame = initialMetrics === null || initialMetrics === void 0 ? void 0 : initialMetrics.frame) !== null && _initialMetrics_frame !== void 0 ? _initialMetrics_frame : parentFrame) !== null && _ref2 !== void 0 ? _ref2 : {
        // Backwards compat so we render anyway if we don't have frame.
        x: 0,
        y: 0,
        width: Dimensions.get("window").width,
        height: Dimensions.get("window").height
    }), 2), frame = _React_useState1[0], setFrame = _React_useState1[1];
    var onInsetsChange = React.useCallback(function(event) {
        var _event_nativeEvent = event.nativeEvent, nextFrame = _event_nativeEvent.frame, nextInsets = _event_nativeEvent.insets;
        setFrame(function(frame) {
            if (// Backwards compat with old native code that won't send frame.
            nextFrame && (nextFrame.height !== frame.height || nextFrame.width !== frame.width || nextFrame.x !== frame.x || nextFrame.y !== frame.y)) {
                return nextFrame;
            } else {
                return frame;
            }
        });
        setInsets(function(insets) {
            if (!insets || nextInsets.bottom !== insets.bottom || nextInsets.left !== insets.left || nextInsets.right !== insets.right || nextInsets.top !== insets.top) {
                return nextInsets;
            } else {
                return insets;
            }
        });
    }, []);
    return /*#__PURE__*/ _jsx(NativeSafeAreaProvider, _object_spread_props(_object_spread({
        style: StyleSheet.compose(styles.fill, style),
        onInsetsChange: onInsetsChange
    }, others), {
        children: insets != null ? /*#__PURE__*/ _jsx(SafeAreaFrameContext.Provider, {
            value: frame,
            children: /*#__PURE__*/ _jsx(SafeAreaInsetsContext.Provider, {
                value: insets,
                children: children
            })
        }) : null
    }));
}
var styles = StyleSheet.create({
    fill: {
        flex: 1
    }
});
function useParentSafeAreaInsets() {
    return React.useContext(SafeAreaInsetsContext);
}
function useParentSafeAreaFrame() {
    return React.useContext(SafeAreaFrameContext);
}
var NO_INSETS_ERROR = "No safe area value available. Make sure you are rendering `<SafeAreaProvider>` at the top of your app.";
export function useSafeAreaInsets() {
    var insets = React.useContext(SafeAreaInsetsContext);
    if (insets == null) {
        throw new Error(NO_INSETS_ERROR);
    }
    return insets;
}
export function useSafeAreaFrame() {
    var frame = React.useContext(SafeAreaFrameContext);
    if (frame == null) {
        throw new Error(NO_INSETS_ERROR);
    }
    return frame;
}
export function withSafeAreaInsets(WrappedComponent) {
    return /*#__PURE__*/ React.forwardRef(function(props, ref) {
        var insets = useSafeAreaInsets();
        return /*#__PURE__*/ _jsx(WrappedComponent, _object_spread_props(_object_spread({}, props), {
            insets: insets,
            ref: ref
        }));
    });
}
/**
 * @deprecated
 */ export function useSafeArea() {
    return useSafeAreaInsets();
}
/**
 * @deprecated
 */ export var SafeAreaConsumer = SafeAreaInsetsContext.Consumer;
/**
 * @deprecated
 */ export var SafeAreaContext = SafeAreaInsetsContext;
